import { useEffect } from 'react';

const useInputFocus = (errors, submitCount , clickbtnsub)=> {
   
        useEffect(() => {
          
        if (submitCount >= 0 && errors && clickbtnsub) { 
          const keys = Object.keys(errors);
          if (keys.length > 0) {
            const firstInput = document.getElementById(`${Object.keys(errors)[0]}`)  
              firstInput?.focus();
            
          }
           
        }
      }, [errors, submitCount , clickbtnsub]);

      return true
}

export default useInputFocus;
